import { useContext, useEffect, useMemo, useRef, useState } from "react"
import { callautopopulate } from "../../../services/callautopop";
import _ from "underscore";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ToastContext } from "../../../context/ToastContext";
import { dateConvert, timePickerMuiCss, timeStringToDate } from "../../../utils/Helper";
import { Calendar } from "primereact/calendar";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import * as XLSX from 'xlsx';

export const useShareEvaluatorSurvey = ({ surveyData, fromDirectRes }) => {

    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const [fieldValues, setFieldValues] = useState({ questions: {}, roles: [], leads: [], projects: [], technology: [], status: [], users: [], user_list: { projects: [], users: [], leads: [], technologies: [], roles: [], is_change: false }, survey_status: { survey_session_status_name: "All", survey_session_status_key: "all" }, survey_status_count: {} });
    const [options, setOptions] = useState({ user_wise_roles: [], roles: [], projects: [], leads: [], all_users: [], users: [], technology: [], session_status: [], evaluated_users: [], user_status: [], evaluatorList: [], evaluatorOpt: [], allEvaluator: [] });
    const [surveyQuestions, setSurveyQuestions] = useState([]);
    const [showConfirmation, setShowConfirmation] = useState({ delete_question_set: { data: [], visible: false }, delete_session: { data: [], visible: false } });
    const overlayRef = useRef(null);
    const [rowData, setRowData] = useState({ question_set: [], user_list: [], session_slot: [], user_list_filtered: [], all_question_set: [], session_slot_filtered: [] });
    const [selectedUserList, setSelectedUserList] = useState([]);
    const [loader, setLoader] = useState({ user_list: false, generate_slot_btn: false, session_grid: false });
    const [generateSlot, setGenerateSlot] = useState({ number_of_members: "0", number_of_slots: "0", slot_duration_days: "0", slot_break_days: "0", slot_start_datetime: null, start_time: null, end_time: null });
    const [activeStep, setActiveStep] = useState("question_set");
    const [evaluatorList, setEvaluatorList] = useState({ visible: false, data: [], user: "" });
    const [extend, setExtend] = useState({ data: [], end_date: null, end_time: null });
    const [editingRows, setEditingRows] = useState({ attribute: {}, data: {} });
    const [selectedRow, setSelectedRow] = useState([])
    const extendFlag = useRef(false);
    const listBoxRef = useRef(null);

    const columns = [
        {
            key: "",
            label: "",
            checkbox: true,
            style: { width: "10%" },
            sort: false,
            render: (row, isAll) => {
                const data = options?.evaluatorList?.[0]?.children
                const isChecked = isAll

                    ? (data?.length > 0 && selectedRow?.length === data?.length)
                    : _.some(selectedRow, (item) => _.isEqual(item, row));
                return (
                    <div className="d-flex justify-content-center w100">
                        <input type="checkbox" className="input-dd" checked={isChecked} onChange={() => handleChange(row, isAll)} />
                    </div>
                );
            },

        },
        {
            key: "target_user_display_name",
            label: "Subject User",
            style: { width: "45%" },
        },
        {
            key: "evaluator_user_display_name",
            label: "Evaluator",
            style: { width: "45%" },
        },
    ]


    const handleChange = (row, isAll) => {
        if (isAll) {
            const rowData = options?.evaluatorList?.[0]?.children
            const isAllSelected = rowData.length > 0 && selectedRow.length === rowData.length;
            setSelectedRow(isAllSelected ? [] : [...rowData]);
        } else {
            setSelectedRow(prev => {
                const isSelected = _.some(prev, (item) => _.isEqual(item, row));
                if (isSelected) {
                    return _.filter(prev, (item) => !_.isEqual(item, row));
                } else {
                    return [...prev, row];
                }
            });
        }
    };

    useEffect(() => {
        callautopopulate("role_on_project", "project_leads", "users", "technology", "survey_session_status", "projects", "user_status", "day_calendar_groups", "control_center_user_category")?.then(res => {

            const roles = _.uniq(_.pluck(res?.role_on_project, "role_on_project"))
            const session_status = [{ survey_session_status_name: "All", survey_session_status_key: "all" }]?.concat(res?.survey_session_status);
            setOptions((prev) => ({
                ...prev,
                user_wise_roles: res?.role_on_project,
                roles: _.sortBy(roles),
                projects: _.sortBy(res?.projects, "project_name"),
                leads: _.sortBy(res?.project_leads, "user_display_name"),
                all_users: _.sortBy(res?.users, "user_display_name"),
                users: _.sortBy(res?.users, "user_display_name"),
                technology: _.sortBy(res?.technology, "technology_name"),
                user_status: _.sortBy(res?.user_status, "user_status"),
                units: _.sortBy(res?.day_calendar_groups, "group_name"),
                category: _.sortBy(res?.control_center_user_category, "user_category_name"),
                session_status
            }));
        })

        let questions = [];

        const sortedCategory = _.sortBy(surveyData?.survey_question_details, "category_order_number");
        _.filter(sortedCategory, quest => quest?.category_order_number > 0)?.concat(_.filter(sortedCategory, quest => quest?.category_order_number === 0))?.forEach((item) => {
            if (_.isEmpty(_.findWhere(questions, { category: item?.question_category_key }))) {
                const questList = _.sortBy(_.filter(surveyData?.survey_question_details, ques => ques?.question_category_key === item?.question_category_key), "question_order_number");
                const combinedQuest = _.filter(questList, quest => quest?.question_order_number > 0)?.concat(_.filter(questList, quest => quest?.question_order_number === 0))
                questions.push({
                    category: item?.question_category_key,
                    id: item?.question_category_id,
                    name: item?.question_category_name,
                    questions: _.uniq(combinedQuest, "question_id")
                })
            }
        })
        setSurveyQuestions(questions);
        getEvalutereList()
    }, [])


    useEffect(() => {
        if (activeStep === "session_slot") {
            getSurveySessionSlots();
        }
    }, [fieldValues?.survey_status, activeStep])

    useEffect(() => {
        if (!fromDirectRes) {
            setFieldValues((prev) => ({ ...prev, questions: {}, users: [] }));
            if (activeStep === "question_set") {
                getUserQuestionSets();
                setFieldValues((prev) => ({ ...prev, user_list: { ...prev?.user_list, projects: [], users: [], leads: [], technologies: [], roles: [], is_change: false } }));
            } else if (activeStep === "session_slot") {
                getSurveyUserList();
                setFieldValues((prev) => ({ ...prev, questions: {}, roles: [], leads: [], users: [] }));
            }
        }
    }, [activeStep])

    useEffect(() => {
        if (!_.isEmpty(fieldValues?.users)) {
            const currentScroll = listBoxRef.current?.scrollTop;
            setOptions((prev) => ({
                ...prev,
                users: _.uniq([..._.sortBy(fieldValues?.users, "user_display_name"), ...prev?.users], "user_code")
            }));
            setTimeout(() => {
                if (listBoxRef?.current) {
                    listBoxRef.current.scrollTop = currentScroll;
                }
            }, 0);
        }
    }, [fieldValues?.users]);

    const getUserQuestionSets = async () => {
        try {
            const res = await services.getInvokeRemote("POST", Urls("GETUSEREVALUATIONTARGETQUESTIONLIST"), { survey_id: surveyData?.survey_details?.[0]?.survey_id });
            if (res) {
                const data = _.map(res?.body?.data?.user_evaluation_target_question_data, (item) => {
                    return {
                        ...item,
                        evaluator_user_code: _.uniq(item?.evaluator_user_codes?.split(","))?.[0],
                        evaluator_user_display_name: _.uniq(item?.evaluator_user_display_name?.split(","))?.[0]
                    };
                });


                setRowData((prev) => ({ ...prev, question_set: data, all_question_set: data }));
            }
        } catch (error) {
            console.error("Error: ", error);
        }
    }
    useEffect(() => {
        const data = fieldValues?.isAssociated ? rowData?.all_question_set : options?.allEvaluator
        const evaluators = [...new Map(data.map(obj => [obj.evaluator_user_code, {
            user_display_name: obj?.evaluator_user_display_name,
            user_code: obj.evaluator_user_code
        }])).values()];
        const subjectUsers = [...new Map(data.map(obj => [obj.target_user_code, {
            user_display_name: obj?.target_user_display_name,
            user_code: obj.target_user_code
        }])).values()];
        setOptions((prev) => ({
            ...prev, evaluatorOpt: evaluators, subjectOpt: subjectUsers,
        }))
        const updatedEvaluater = _.filter(evaluators, (item) => fieldValues?.evaluater?.includes(item?.user_code))
        const updatedSubjectUser = _.filter(evaluators, (item) => fieldValues?.subjectUser?.includes(item?.user_code))
        setFieldValues((prev) => ({ ...prev, evaluater: updatedEvaluater, subjectUser: updatedSubjectUser }))
    }, [fieldValues?.isAssociated, rowData?.all_question_set, options?.allEvaluator])

    const handleQuestionSetSave = async () => {
        try {
            if (_.isEmpty(fieldValues?.questions?.questions)) {
                showInfo("Info", "Please select aleast 1 question");
                return;
            } else if (_.isEmpty(selectedRow)) {
                showInfo("Info", "Please sleect atleast 1 user");
                return;
            }
            const groupedByEvaluator = _.groupBy(selectedRow, 'target_user_code');
            const tvpData = _.map(groupedByEvaluator, (rows, evaluatorCode) => {
                const subjectCodes = _.uniq(_.pluck(rows, "evaluator_user_code"));
                return {
                    target_user_code: parseInt(evaluatorCode),
                    evaluator_user_codes: subjectCodes?.toString(),
                    question_ids: _.filter(_.pluck(Object.values(fieldValues?.questions?.questions), "question_id"), item => item && item !== 0)?.toString() || ""
                };
            })
            const payload = {
                "survey_id": surveyData?.survey_details?.[0]?.survey_id,
                "target_user_questions": tvpData || []
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTUSEREVALUATIONTARGETQUESTION"), payload);
            if (res) {
                showSuccess("Success", res?.body?.message);
                getUserQuestionSets();
                getEvalutereList();
                setSelectedRow([])
            }
        } catch (error) {
            console.error("Error: ", error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    const deleteQuestionSet = async (rowdata, confirm) => {
        try {
            if (!confirm) {
                setShowConfirmation((prev) => ({ ...prev, delete_question_set: { data: rowdata, visible: true } }));
                return;
            }
            const payload = {
                survey_id: surveyData?.survey_details?.[0]?.survey_id,
                target_user_code: rowdata?.target_user_code,
                evaluator_user_code: parseInt(rowdata?.evaluator_user_code) || 0
            }
            const res = await services.getInvokeRemote("POST", Urls("REMOVEUSEREVALUATIONTARGETQUESTIONS"), payload);
            if (res) {
                showSuccess("Success", res?.body?.message);
                getUserQuestionSets();
                getEvalutereList();
                setShowConfirmation((prev) => ({ ...prev, delete_question_set: { visible: false, data: [] } }));
            }
        } catch (error) {
            console.error("Error: ", error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    const getSurveyUserList = async (key) => {
        try {
            setLoader((prev) => ({ ...prev, user_list: true }));
            const payload = {
                "survey_id": surveyData?.survey_details?.[0]?.survey_id || 0,
                "project_lead_user_code": key === "leads" ? "" : _.pluck(fieldValues?.user_list?.leads, "user_code")?.toString(),
                "role_on_projects": key === "roles" ? "" : fieldValues?.user_list?.roles?.toString(),
                "technologies": key === "technologies" ? "" : _.pluck(fieldValues?.user_list?.technologies, "technology_name")?.toString(),
                "project_ids": key === "projects" ? "" : _.pluck(fieldValues?.user_list?.projects, "project_id")?.toString()
            }
            const res = await services.getInvokeRemote("POST", Urls("GETSURVEYUSERLIST"), payload);
            if (res) {
                const data = _.sortBy(res?.body?.data?.survey_user_list, "user_display_name");
                setRowData((prev) => ({ ...prev, user_list: data, user_list_filtered: data }));
                setOptions((prev) => ({ ...prev, evaluated_users: data }));
                setFieldValues((prev) => ({ ...prev, user_list: { ...prev?.user_list, is_change: false } }));
                setLoader((prev) => ({ ...prev, user_list: false }));
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader((prev) => ({ ...prev, user_list: false }));
        }
    }

    const generateUserSurveySlotSession = async () => {
        try {
            const startDate = `${dateConvert(generateSlot?.slot_start_datetime, "iso-string")?.split("T")?.[0]}T${dateConvert(generateSlot?.start_time, "hour-min")}`;
            if (_.isEmpty(selectedUserList)) {
                showInfo("Info", "Please select atleast 1 user");
                return;
            } else if ((parseInt(generateSlot?.number_of_slots || 0) < 1 && parseInt(generateSlot?.number_of_members || 0) < 1)) {
                showInfo("Info", "Members and Slots both cannot be 0");
                return;
            }
            else if (parseInt(generateSlot?.slot_break_days) < 0) {
                showInfo("Info", "Break days cannot be less than zero");
                return;
            } else if (!generateSlot?.slot_start_datetime) {
                showInfo("Info", "Please select the slot start date");
                return;
            } else if (!generateSlot?.start_time) {
                showInfo("Info", "Please select the slot start time");
                return;
            } else if (!generateSlot?.end_time && !parseInt(generateSlot?.slot_duration_days)) {
                showInfo("Info", "Please select the slot end date");
                return;
            }
            else if (new Date(startDate) < new Date() || new Date(surveyData?.survey_details?.[0]?.start_datetime) > new Date(startDate)) {
                showInfo("Info", "Slot start date cannot be less than today/survey start date");
                return;
            } else if (new Date(startDate) >= new Date(surveyData?.survey_details?.[0]?.end_datetime)) {
                showInfo("Info", "Slot start date cannot be greater than survey end date");
                return;
            }
            setLoader((prev) => ({ ...prev, generate_slot_btn: true }));
            const payload = {
                "survey_id": surveyData?.survey_details?.[0]?.survey_id,
                "session_user_codes": _.pluck(selectedUserList, "user_code")?.toString() || "",
                "slot_start_datetime": startDate || "",
                "number_of_members": !generateSlot?.number_of_members?.trim() ? 0 : parseInt(generateSlot?.number_of_members) || 0,
                "number_of_slots": !generateSlot?.number_of_slots?.trim() ? 0 : parseInt(generateSlot?.number_of_slots) || 0,
                "slot_duration_days": parseInt(generateSlot?.slot_duration_days) || 0,
                "slot_break_days": parseInt(generateSlot?.slot_break_days) || 0,
                "end_time": generateSlot?.end_time ? dateConvert(new Date(generateSlot?.end_time), "iso-string") : ""
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTUSERSURVEYSLOTSESSION"), payload);
            if (res) {
                showSuccess("Success", res?.body?.message);
                setGenerateSlot({ number_of_members: "0", number_of_slots: "0", slot_duration_days: "0", slot_break_days: "0", slot_start_datetime: null });
                setSelectedUserList([]);
                setLoader((prev) => ({ ...prev, generate_slot_btn: false }));
                getSurveySessionSlots(null, true);
                getSurveyUserList();
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader((prev) => ({ ...prev, generate_slot_btn: false }));
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    const getSurveySessionSlots = async (status, getAll) => {
        try {
            setLoader((prev) => ({ ...prev, session_grid: true }));
            const status_key = getAll ? "" : status ? status?.survey_session_status_key : fieldValues?.survey_status?.survey_session_status_key;
            const payload = {
                "survey_id": surveyData?.survey_details?.[0]?.survey_id,
                "survey_session_status": status_key === "all" ? "" : status_key || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("GETUSERSURVEYSLOTSESSION"), payload);
            if (res) {
                const data = res?.body?.data?.user_session_details;
                setRowData((prev) => ({ ...prev, session_slot: data, session_slot_filtered: fieldValues?.search ? _.filter(data, item => item?.user_display_name?.toLowerCase()?.includes(fieldValues?.search?.toLowerCase())) : data }));

                // calculate status count only when "all" slots received
                if (payload?.survey_session_status === "") {
                    let statusCount = {}
                    _.uniq(_.pluck(data, "survey_session_status"))?.forEach(status => {
                        statusCount = { ...statusCount, [status]: _.filter(data, { survey_session_status: status })?.length || 0 };
                    })
                    setFieldValues((prev) => ({ ...prev, survey_status_count: statusCount }))
                }
                setLoader((prev) => ({ ...prev, session_grid: false }));
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader((prev) => ({ ...prev, session_grid: false }));
        }
    }

    const deleteSession = async (rowdata, confirm) => {
        try {
            if (!confirm) {
                setShowConfirmation((prev) => ({ ...prev, delete_session: { data: rowdata, visible: true } }));
                return;
            }
            const payload = {
                "survey_id": surveyData?.survey_details?.[0]?.survey_id,
                "survey_session_id": rowdata?.survey_session_id
            }
            const res = await services.getInvokeRemote("POST", Urls("REMOVEUSERSURVEYSESSION"), payload);
            if (res) {
                showSuccess("Success", res?.body?.message);
                getSurveySessionSlots(null, true);
                setShowConfirmation((prev) => ({ ...prev, delete_session: { visible: false, data: [] } }));
                !fromDirectRes && getSurveyUserList();
            }
        } catch (error) {
            console.error("Error: ", error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    const handleSaveExtendTime = async (e) => {
        try {
            if (_.isEmpty(extend?.data) && !e) {
                showInfo("Info", "Please select slot to extend");
                return;
            } else if (!extend?.end_date && !e) {
                showInfo("Info", "Please select extend date");
                return;
            } else if (!extend?.end_time && !e) {
                showInfo("Info", "Please select extend time");
                return;
            }
            const endDate = e ? dateConvert(e?.newData?.end_datetime, "iso-string") : dateConvert(timeStringToDate(dateConvert(extend?.end_time, "hour-min"), extend?.end_date), "iso-string");
            if (dateConvert(new Date(), "iso-string") > endDate) {
                showInfo("Info", "New session end date cannot be less than current date");
                extendFlag.current = false;
                setTimeout(() => {
                    setEditingRows((prev) => ({
                        ...prev,
                        attribute: { ...prev?.attribute, [e.data?.survey_session_id]: true },
                        data: { [e?.data?.survey_session_id]: endDate }
                    }));
                }, 0);
                return;
            } else if (dateConvert(surveyData?.survey_details?.[0]?.end_datetime, "iso-string") < endDate) {
                showInfo("Info", "Session end date cannot be greater than survey end date");
                extendFlag.current = false;
                setTimeout(() => {
                    setEditingRows((prev) => ({
                        ...prev,
                        attribute: { ...prev?.attribute, [e.data?.survey_session_id]: true },
                        data: { [e.data?.survey_session_id]: endDate }
                    }));
                }, 0);
                return;
            }
            const payload = {
                "survey_id": surveyData?.survey_details?.[0]?.survey_id,
                "survey_session_ids": (e ? e?.newData?.survey_session_id?.toString() : _.pluck(extend?.data, "survey_session_id")?.toString()) || "",
                "survey_end_datetime": endDate || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("SAVESURVEYSESSIONTIMEEXTEND"), payload);
            if (res) {
                showSuccess("Success", res?.body?.message);
                getSurveySessionSlots(null, true);
                setExtend((prev) => ({ ...prev, data: [], end_date: null, end_time: null }));
                setEditingRows((prev) => ({ ...prev, attribute: {}, data: {} }));
            }
        } catch (error) {
            console.error("Error", error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    const listBoxOptionTemplate = (option) => {
        return (
            <div className="d-flex align-items-center gap-3">
                <input type='checkbox' checked={_.pluck(fieldValues?.users, "user_code")?.includes(option?.user_code)}
                    onChange={(e) => {
                        let dataArray = [...fieldValues?.users];
                        if (e.target?.checked) {
                            dataArray.push(option);
                        } else {
                            dataArray = _.filter(dataArray, item => item?.user_code !== option?.user_code);
                        }
                        setFieldValues((prev) => ({ ...prev, users: dataArray }));
                    }}
                />
                <div>{option?.user_display_name}</div>
            </div>
        );
    };

    const listBoxFilterTemplate = (option) => {
        const allSelected = fieldValues?.users?.length > 0 && _.every(options?.users, item => _.pluck(fieldValues?.users, "user_code")?.includes(item?.user_code));
        const handleSelectAll = (checked) => {
            setFieldValues((prev) => ({ ...prev, users: checked ? [...options?.users] : [] }));
        };

        return (
            <div className="d-flex align-items-center gap-2 px-1">
                <input type="checkbox" checked={allSelected} onChange={(e) => handleSelectAll(e?.target?.checked)} />
                <div className='w95 border'>{option?.element}</div>
            </div>
        );
    };


    const dataTableColumns = {
        question_set: [
            {
                field: "target_user_display_name",
                headerName: "Subject",
                width: "30%",
            },
            {
                field: "evaluator_user_display_name",
                headerName: "Evaluator",
                width: "30%",
            },

            {
                field: "question_count",
                headerName: "Que",
                width: "13%"
            },
            {
                field: "question_category_display_name",
                headerName: "Category",
                width: "25%",
            },
            {
                field: "actions",
                headerName: "Action",
                width: "2%",
            },
        ],
        user_list: [
            {
                field: "user_display_name",
                headerName: "Evaluators",
                flex: 2
            },
            {
                field: "total_work_experience",
                headerName: "YoE",
                flex: 0.5
            },
            {
                field: "evaluator_user_names",
                headerName: "Subject",
                flex: 1
            },
            {
                field: "project_name",
                headerName: "Project",
                flex: 2
            },
        ],
        session_list: [
            {
                field: "user_display_name",
                headerName: "Evaluator",
                width: "30%"
            },
            {
                field: "target_users",
                headerName: "Subject",
                width: "5%"
            },
            {
                field: "start_datetime",
                headerName: "Start Date",
                width: "25%"
            },
            {
                field: "end_datetime",
                headerName: "End Date",
                width: "25%"
            },
            {
                field: "survey_session_status",
                headerName: "Status",
                width: "10%"
            },
        ]
    }

    const dataTableBodyTemplate = {
        question_set: (rowdata, col) => {
            return (
                col?.field === "actions" ?
                    <div className="">
                        {/* <div className="c-pointer" onClick={() => handleEdit(rowdata)}><FontAwesomeIcon icon="fa-solid fa-edit" /></div> */}
                        <div className="text-danger c-pointer" onClick={() => deleteQuestionSet(rowdata)}><FontAwesomeIcon icon="fa-solid fa-trash" /></div>
                    </div> :
                    <div>{rowdata?.[col?.field]}</div>
            )
        },
        user_list: (rowdata, col) => {
            return (
                col?.field === "evaluator_user_names" ?
                    <div title={_.sortBy(_.uniq(rowdata?.[col?.field]?.split(",")))?.join("\n")} className="c-pointer fw-semibold text-decoration-underline" onClick={() => setEvaluatorList((prev) => ({ ...prev, visible: true, data: _.sortBy(_.uniq(rowdata?.[col?.field]?.split(","))), user: rowdata?.user_display_name }))}>{rowdata?.total_targeted_users}</div> :
                    <div>{rowdata?.[col?.field]}</div>
            )
        },
        session_slot: (rowdata, col) => {
            return (
                (col?.field === "start_datetime" || col?.field === "end_datetime") ?
                    <div >
                        <div>{dateConvert(rowdata?.[col?.field], "date-time-months")}</div>
                    </div> : col?.field === "target_users" ?
                        <div title={_.uniq(rowdata?.target_users?.split(","))?.join("\n")} className="c-pointer" onClick={() => setEvaluatorList((prev) => ({ ...prev, visible: true, data: _.uniq(rowdata?.target_users?.split(",")), user: rowdata?.user_display_name }))}>{_.uniq(rowdata?.target_users?.split(","))?.length}</div>
                        : <div>{rowdata?.[col?.field]}</div>
            )
        },
        session_slot_action: (rowdata, options) => {
            return (
                <div>
                    {options?.rowEditor?.editing ?
                        <div className="d-flex align-items-center justify-content-center">
                            <div className="c-pointer" onClick={(e) => options?.rowEditor?.onSaveClick(e)} style={{ fontSize: "0.85rem", width: "2rem", height: "auto" }}><FontAwesomeIcon icon="fa-solid fa-floppy-disk" /></div>
                            <div className="c-pointer" onClick={(e) => options?.rowEditor?.onCancelClick(e)} style={{ fontSize: "0.85rem", width: "2rem", height: "auto" }}><FontAwesomeIcon icon="fa-solid fa-close" /></div>
                        </div> :
                        <div className="d-flex align-items-center justify-content-center">
                            {extend?.data?.length === 0 && <div {...options?.rowEditor?.element?.props} style={{ fontSize: "0.85rem", width: "2rem", height: "auto" }} title="Extend End Date"><FontAwesomeIcon icon="fa-solid fa-calendar" /></div>}
                            <div className="text-danger text-center c-pointer" onClick={() => deleteSession(rowdata)} style={{ fontSize: "0.85rem", width: "2rem", visibility: (rowdata?.survey_session_status !== "active" && rowdata?.survey_session_status !== "completed" && rowdata?.survey_session_status !== "expired") ? "visible" : "hidden" }}><FontAwesomeIcon icon="fa-solid fa-trash" /></div>
                        </div>
                    }

                </div>
            );
        }
    }

    const generateSlotFields = [
        {
            label: "Members",
            name: "number_of_members",
            col: "12",
            custom_col: "7",
            type: "text",
            validation_type: "number",
            required: true,
        },
        {
            label: "Slot",
            name: "number_of_slots",
            col: "5",
            type: "text",
            validation_type: "number",
            required: true,
        },
        {
            label: "Duration (Days)",
            name: "slot_duration_days",
            col: "6",
            type: "text",
            validation_type: "number",
            required: false,
        },
        {
            label: "Break (Days)",
            name: "slot_break_days",
            col: "6",
            type: "text",
            validation_type: "number",
            required: true,
        },
        {
            label: "Slot Start Date",
            name: "slot_start_datetime",
            col: "6",
            type: "date",
            required: true,
        },
        {
            label: "Slot Start Time",
            name: "start_time",
            col: "6",
            type: "timepicker",
            required: true,
        },
        {
            label: "Slot End Time",
            name: "end_time",
            col: "6",
            type: "timepicker",
            required: false,
        },
    ]

    const handleSlotFormChange = (e, field) => {
        let val = e.target?.value;
        if (field?.name === "start_time" || field?.name === "end_time") {
            val = e
        } else if (field?.validation_type === "number") {
            const regex = /^\d*$/;
            if (!regex?.test(val)) {
                return;
            }
            if (field?.name === "number_of_members" && parseInt(val) > 0) {
                setGenerateSlot((prev) => ({ ...prev, number_of_slots: "0" }));
            } else if (field?.name === "number_of_slots" && parseInt(val) > 0) {
                setGenerateSlot((prev) => ({ ...prev, number_of_members: "0" }));
            }
        }
        setGenerateSlot((prev) => ({ ...prev, [field?.name]: val }));
    }

    const endDateEditor = (options) => {
        let date = editingRows?.data?.[options?.rowData?.survey_session_id] ? editingRows?.data?.[options?.rowData?.survey_session_id]?.split(".")?.[0] : options?.value;
        if (editingRows?.data?.[options?.rowData?.survey_session_id] && !_.isEqual(new Date(editingRows?.data?.[options?.rowData?.survey_session_id]?.split(".")?.[0]), new Date(options?.value)) && !extendFlag.current) {
            options.editorCallback(date);
            extendFlag.current = true;
        }
        setExtend((prev) => ({ ...prev, date: options?.rowData?.end_datetime }));
        const handleChange = (e, key) => {
            setEditingRows((prev) => ({ ...prev, data: {} }))
            if (key === "end_date") {
                if (!e?.value) {
                    date = null;
                    showInfo("Info", "Invalid date");
                    return;
                }
                date = timeStringToDate(dateConvert(options?.value, "hour-min"), new Date(e?.value));
            } else {
                if (!e) {
                    date = null;
                    showInfo("Info", "Invalid time");
                    return;
                }
                date = timeStringToDate(dateConvert(e, "hour-min"), new Date(options?.value));
            }
            options.editorCallback(date);
        }
        return (
            <div className='d-flex gap-2 align-items-center inspectra-calendar'>
                <Calendar value={new Date(options?.value)} onChange={(e) => handleChange(e, "end_date")} placeholder="Select extend date" className='input-dd' dateFormat='dd-mm-yy' maxDate={new Date(surveyData?.survey_details?.[0]?.end_datetime)} minDate={new Date(surveyData?.survey_details?.[0]?.start_datetime)} />
                <TimePicker sx={{ ...timePickerMuiCss }} value={new Date(options?.value)} onChange={(e) => handleChange(e, "end_time")} slotProps={{ textField: { label: "Extend Time", error: false, InputLabelProps: { shrink: true } } }} />
            </div>
        );

    }

    const handleUserChange = () => {
        let filteredData = rowData?.user_list;
        if (!_.isEmpty(fieldValues?.user_list?.users)) {
            filteredData = _.filter(filteredData, item => _.pluck(fieldValues?.user_list?.users, "user_code")?.includes(item?.user_code));
        }
        setRowData((prev) => ({ ...prev, user_list_filtered: filteredData }));
    }

    const getEvalutereList = async () => {
        try {
            const payload = {
                "survey_id": surveyData?.survey_details?.[0]?.survey_id || 0,
                "employee_user_code": "",
                "evaluator_user_code": "",
                "status_key": "verified",
                "unit_ids": "",
                "survey_view_type": "reporting"
            }
            const res = await services.getInvokeRemote("POST", Urls("GETEVALUATORVERIFIEDMAPPINGLIST"), payload)
            if (!res?.body?.error_status) {
                const data = _.sortBy(res?.body?.data?.survey_user_evaluator_verified_mapping_list, "user_display_name");
                setOptions((prev) => ({
                    ...prev, allEvaluator: data, evaluatorList: [{
                        id: "all",
                        title: "",
                        children: data || []
                    }]
                }))
            }

        } catch (error) {
            console.error(error)
        }
    }
    useEffect(() => {
        handleFilter()
    }, [fieldValues?.evaluater, fieldValues?.subjectUser, fieldValues?.projects, fieldValues?.status, fieldValues?.leads, fieldValues?.units, fieldValues?.category, rowData?.all_question_set, options?.allEvaluator]);

    const handleReset = () => {
        setFieldValues((prev) => ({ ...prev, leads: [], roles: [], projects: [], technology: [], status: [], units: [], subjectUser: [], evaluater: [] }))
    }

    const handleFilter = () => {
        let filterValue = fieldValues.isAssociated ? rowData?.all_question_set : options?.allEvaluator
        if (_.isEmpty(fieldValues?.evaluater) && _.isEmpty(fieldValues?.subjectUser) && _.isEmpty(fieldValues?.projects) && _.isEmpty(fieldValues?.status) && _.isEmpty(fieldValues?.leads) && _.isEmpty(fieldValues?.category) && _.isEmpty(fieldValues?.units)) {
            filterValue = fieldValues.isAssociated ? rowData?.all_question_set : options?.allEvaluator
        }
        if (!_.isEmpty(fieldValues?.evaluater)) {
            filterValue = filterValue?.filter(item => fieldValues?.evaluater?.includes(item.evaluator_user_code));
        }
        if (!_.isEmpty(fieldValues?.subjectUser)) {
            filterValue = filterValue?.filter(item => fieldValues?.subjectUser?.includes(item.target_user_code));
        }
        if (!_.isEmpty(fieldValues?.projects)) {
            filterValue = filterValue?.filter(item => fieldValues?.projects?.includes(item.project_id));
        }
        if (!_.isEmpty(fieldValues?.status)) {
            filterValue = filterValue?.filter(item => fieldValues?.status?.includes(item?.user_status_id));
        }
        if (!_.isEmpty(fieldValues?.leads)) {
            filterValue = filterValue?.filter(item => fieldValues?.leads?.includes(item?.lead_user_code));
        }
        if (!_.isEmpty(fieldValues?.category)) {
            filterValue = filterValue?.filter(item => fieldValues?.category?.includes(item?.user_category_id));
        }
        if (!_.isEmpty(fieldValues?.units)) {
            filterValue = filterValue?.filter(item => fieldValues?.units?.includes(item?.group_id));
        }
        if (fieldValues.isAssociated) {
            setRowData((prev) => ({ ...prev, question_set: filterValue }));
        } else {
            setOptions((prev) => ({
                ...prev, evaluatorList: [{
                    id: "all",
                    title: "",
                    children: filterValue || []
                }]
            }));
        }

    };


    const handleExcelDownload = () => {
        if (_.isEmpty(rowData?.question_set)) {
            showInfo("Info", "There is no data to download");
            return
        }
        const exportData = rowData?.question_set.map(row => {
            const item = {};
            dataTableColumns.question_set.forEach(col => {
                if (col.field !== 'actions') {
                    item[col.headerName] = row[col.field];
                }
            });
            return item;
        });

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "SurveyData");
        worksheet['!cols'] = [{ wch: 20 }, { wch: 25 }, { wch: 15 }];
        XLSX.writeFile(workbook, "Question_Set.xlsx");
    };



    return useMemo(() => ({
        fieldValues, setFieldValues, options, overlayRef, surveyQuestions, listBoxFilterTemplate, listBoxOptionTemplate, rowData, handleQuestionSetSave, deleteQuestionSet, showConfirmation, setShowConfirmation, selectedUserList, setSelectedUserList, dataTableBodyTemplate, dataTableColumns, getSurveyUserList, loader, generateSlotFields, generateSlot, generateUserSurveySlotSession, activeStep, setActiveStep, deleteSession, getSurveySessionSlots, evaluatorList, setEvaluatorList, handleSlotFormChange, extend, setExtend, handleSaveExtendTime, endDateEditor, handleUserChange, editingRows, setEditingRows, listBoxRef, columns, handleFilter, handleExcelDownload, selectedRow, handleReset, setRowData
    }), [fieldValues, setFieldValues, options, overlayRef, surveyQuestions, listBoxFilterTemplate, listBoxOptionTemplate, rowData, handleQuestionSetSave, deleteQuestionSet, showConfirmation, setShowConfirmation, selectedUserList, setSelectedUserList, dataTableBodyTemplate, dataTableColumns, getSurveyUserList, loader, generateSlotFields, generateSlot, generateUserSurveySlotSession, activeStep, setActiveStep, deleteSession, getSurveySessionSlots, evaluatorList, setEvaluatorList, handleSlotFormChange, extend, setExtend, handleSaveExtendTime, endDateEditor, handleUserChange, editingRows, setEditingRows, listBoxRef, columns, handleFilter, handleExcelDownload, selectedRow, handleReset, setRowData])
}